import Vue from 'vue'
import { DashboardService } from "@/common/api.service";
import { FETCH_DASHBOARD_DATA, FETCH_TIME_DATA, FETCH_DASHBOARD_QUIZ_DATA ,FETCH_DASHBOARD_DOCUMENTS, RESET_STATE } from "./actions.type";
import { SET_DASHBOARD_DATA, SET_SESSION_TIME_DATA  ,SET_DASHBOARD_DOCUMENTS, STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        dashboarddocuments: {},
        coursesdata: [],
        timesessiondata:{},
    }
}

let state = initialState()

const getters = {
    dashboarddocuments(state) {
        return state.dashboarddocuments
    },
    coursesdata(state) {
        return state.coursesdata
    },    
    timesessiondata(state) {
        return state.timesessiondata
    },           
}

const actions = {
    async [FETCH_DASHBOARD_DATA](context, slug) {
        const { data } = await DashboardService.get(slug)
        context.commit(SET_DASHBOARD_DATA, data.data)
        return data;
    },
    async [FETCH_TIME_DATA](context, slug) {
        const { data } = await DashboardService.get('sessions?module_id='+slug.moduleid+'&user_id='+slug.userid+'&start_date='+slug.fromdate+'&end_date='+slug.todate)
        context.commit(SET_SESSION_TIME_DATA, {response: data.data, moduleindex: slug.moduleindex, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_QUIZ_DATA](context, slug) {
        const { data } = await DashboardService.get('quiz?module_id='+slug.moduleid+'&user_id='+slug.userid+'&start_date='+slug.fromdate+'&end_date='+slug.todate)
        context.commit(SET_SESSION_TIME_DATA, {response: data.data, moduleindex: slug.moduleindex, course_id:slug.course_id})
        return data;
    },
    async [FETCH_DASHBOARD_DOCUMENTS](context, slug) {
        const { data } = await DashboardService.get('course-documents?course_id='+slug.course_id+'&search='+slug.search)
        context.commit(SET_DASHBOARD_DOCUMENTS, {response: data.data, course_id:slug.course_id})
        return data;
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_SESSION_TIME_DATA](state, data) {
        if(state.timesessiondata.hasOwnProperty(data.course_id) == false){
            Vue.set(state.timesessiondata,data.course_id, {} )
        }
        Vue.set(state.timesessiondata[data.course_id],data.moduleindex, data.response )
    },
    [SET_DASHBOARD_DATA](state, coursesdata) {
        state.coursesdata = coursesdata
    },
    [SET_DASHBOARD_DOCUMENTS](state, documentsdata) {
        Vue.set(state.dashboarddocuments,documentsdata.course_id, documentsdata.response)
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
